import {register} from '@shopify/theme-sections';

import {imageUrl} from '../utils/shopify-images';

const selectors = {
  recoverPasswordLink: '#RecoverPassword',
  hideRecoverPasswordLink: '#HideRecoverPasswordLink',
  recoverPasswordForm: '#RecoverPasswordForm',
  loginForm: '#CustomerLoginForm',
  formState: '.reset-password-success',
  successMessage: '#ResetSuccess',
  galleryJson: '[data-gallery-json]',
  image: '[data-image]',
  caption: '[data-image-caption]',
};

const sectionType = 'main-customers-login';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const container = this.container;
      const galleryJsonElem = container.querySelector(selectors.galleryJson);
      const galleryData = galleryJsonElem ? JSON.parse(galleryJsonElem.innerHTML) : {};
      const images = galleryData.images;
      const imageElem = container.querySelector(selectors.image);
      const captionElem = container.querySelector(selectors.caption);
      const imagesMax = images.length - 1;

      /**
       *  Show/Hide recover password form
       */
      function toggleRecoverPasswordForm() {
        container.querySelector(selectors.recoverPasswordForm).classList.toggle('hide');
        container.querySelector(selectors.loginForm).classList.toggle('hide');
      }

      /**
       *  Select random image from gallery and update image preview
       */
      function updateImage() {
        if (!imageElem) return;

        let randomIndex = Math.floor(Math.random() * imagesMax);
        let image = images[randomIndex];

        if (!image) return;

        // Check if it's the same image as the one currently displayed
        if (image.id === Number(imageElem.dataset.image)) {
          if (randomIndex === imagesMax) {
            randomIndex -= 1;
          } else {
            randomIndex += 1;
          }
          image = images[randomIndex];
        }

        if (!image) return;

        const srcFallback = imageUrl(image.src, 640);
        const srcsetWidths = [160, 320, 480, 640, 800, 960, 1120, 1280, 1440, 1600, 1920];
        let srcset = '';
        srcsetWidths.forEach((width, index) => {
          srcset += `${index > 0 ? ', ' : ''}`;
          srcset += `${imageUrl(image.src, width)} ${width}w`;
        });

        imageElem.src = srcFallback;
        imageElem.srcset = srcset;
        imageElem.dataset.image = image.id;
        captionElem.innerHTML = image.caption;
      }

      function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
        updateImage();
      }

      function checkUrlHash() {
        const hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
          toggleRecoverPasswordForm();
        }
      }

      /**
       *  Show reset password success message
       */
      function resetPasswordSuccess() {
        const formState = container.querySelector(selectors.formState);

        // check if reset password form was successfully submitted.
        if (!formState) {
          return;
        }

        // show success message
        const successMessage = container.querySelector(selectors.successMessage);
        successMessage?.classList.remove('hide');
      }

      const recoverPasswordLink = container.querySelector(selectors.recoverPasswordLink);
      const hideRecoverPasswordLink = container.querySelector(selectors.hideRecoverPasswordLink);
      if (recoverPasswordLink) {
        checkUrlHash();
        resetPasswordSuccess();

        recoverPasswordLink.addEventListener('click', onShowHidePasswordForm);
        hideRecoverPasswordLink?.addEventListener('click', onShowHidePasswordForm);
      }
    },
  });
